module.exports = __webpack_public_path__ + "static/media/close.f6c2dbe0.svg";